/**
 * 判断当前容器是移动端还是pc端
 * 0 移动端
 * 1 pc端
 * */
const getUserBrowser = function () {
    const ua = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(ua)) {
        return 0;
    } else {
        return 1;
    }
};
export default {
    getUserBrowser
};
